var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCheckSquareBroken({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-square-broken"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25065 2.66927C3.3762 2.66927 2.66732 3.37815 2.66732 4.25259V11.7526C2.66732 12.6271 3.3762 13.3359 4.25065 13.3359H11.7507C12.6251 13.3359 13.334 12.6271 13.334 11.7526V7.62757C13.334 7.25938 13.6325 6.96091 14.0007 6.96091C14.3688 6.96091 14.6673 7.25938 14.6673 7.62757V11.7526C14.6673 13.3634 13.3615 14.6693 11.7507 14.6693H4.25065C2.63982 14.6693 1.33398 13.3634 1.33398 11.7526V4.25259C1.33398 2.64176 2.63982 1.33594 4.25065 1.33594H9.50065C9.86884 1.33594 10.1673 1.63441 10.1673 2.0026C10.1673 2.37079 9.86884 2.66927 9.50065 2.66927H4.25065ZM13.7221 3.40619C13.9824 3.66654 13.9824 4.08865 13.7221 4.349L8.47205 9.59897C8.21171 9.85932 7.7896 9.85932 7.52925 9.59897L6.02925 8.09898C5.7689 7.83863 5.7689 7.41652 6.02925 7.15617C6.28959 6.89582 6.7117 6.89582 6.97205 7.15617L8.00065 8.18476L12.7792 3.40619C13.0396 3.14584 13.4617 3.14584 13.7221 3.40619Z",
    fill: "#4A5467"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckSquareBroken);
export default __webpack_public_path__ + "static/media/ic-check-square-broken.4397695d5ba09125e9b4fc965e8e0b76.svg";
export { ForwardRef as ReactComponent };